import React from 'react';
import { Stack, Text, StackItem, IconButton, IIconProps, IStackStyles } from '@fluentui/react';
import { QueueConfiguration, QueueStats, trackEvent } from 'services';
import { DashCardTitle } from './DashCardTitle';
import { useHistory } from 'react-router-dom';

const settingsIcon: IIconProps = { iconName: 'more' };
const gridItemStyle: IStackStyles = {
  root: {
    minWidth: 0
  }
};

export const DashCardTop: React.FunctionComponent<{
  isAdmin: boolean;
  stats: QueueStats;
  config: QueueConfiguration;
}> = props => {
  const history = useHistory();
  const settingsNavigation = (): void => {
    trackEvent('OpenAdminSettings', { component: 'DashCardTop', eventType: 'click', queueId: props.config.id });
    history.push(
      `/settings/tenantId/${props.config.tenant.tenantId}/titleId/${props.config.title.titleId}/subjectType/${props.config.subjectType}`
    );
  };
  return (
    <Stack horizontal>
      <StackItem align="center" grow styles={gridItemStyle}>
        <DashCardTitle config={props.config} />
      </StackItem>
      {props.isAdmin && (
        <StackItem align="center">
          <Text variant="xLargePlus">
            <IconButton iconProps={settingsIcon} title="Settings" ariaLabel="Settings" onClick={settingsNavigation} />
          </Text>
        </StackItem>
      )}
    </Stack>
  );
};

export default DashCardTop;
